import React, {useContext, useState} from 'react';
import {
	Avatar,
	Button,
	Paper,
	Slide, Tab,
	Table,
	TableBody,
	TableCell, TableContainer,
	TableHead,
	TableRow, Tabs,
	Typography,
	Zoom
} from "@mui/material";
import logo from "../../../../../assets/v2/Logo-Orca.svg";
import {green, indigo, orange, purple, red} from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import {setThemeType} from "../../../../../services/AppServices";
import NightsStayTwoToneIcon from "@mui/icons-material/NightsStayTwoTone";
import WbSunnyTwoToneIcon from "@mui/icons-material/WbSunnyTwoTone";
import {innerStyle} from "../../../../../styles/pages/home/MaterialYouBaseStyle";
import {useHistory} from "react-router-dom";
import {AppContext} from "../../../../../App";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {EventoCard} from "./EventoCard";
import {CreaEventoDialog} from "./CreaEventoDialog";

const internalStyle = makeStyles((theme) => ({
	customTab: {
		textTransform: "capitalize",
		[theme.breakpoints.down('lg')]: {
			fontSize: 12
		}
	}
}));

const EventiPage = () => {
	const classes = innerStyle();
	const internalClasses = internalStyle();
	let theme = useTheme();
	let history = useHistory();
	const appContext = useContext(AppContext);
	const [open, setOpen] = useState(false);
	const [value, setValue] = useState(0);
	const [eventoSelected, setEventoSelected] = useState({});
	
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	
	return (
        <React.Fragment>
            <main className={classes.main} style={{width: "100%"}}>
				<header style={{
					display: "flex",
					justifyContent: "center",
					paddingBottom: 28,
					paddingTop: 20,
				}}>
					<Avatar src={logo} variant="circular" className={classes.logo}/>
					<Typography variant={"h1"} component={"h1"} align={"center"}
					            style={{color: indigo["A700"]}}>
						<b>
							cean
						</b>
					</Typography>
				</header>
				<Grid container spacing={4} component={"article"} style={{padding: 20}}>
					<Grid item xs={12}>
						<Slide direction={"up"} in={true} mountOnEnter unmountOnExit style={{transitionDelay: "200ms"}}>
							<Paper className={classes.paper}>
								<Zoom in={true} style={{transitionDelay: "800ms"}}>
									<IconButton
                                        className={classes.backButton}
                                        onClick={() => history.goBack()}
                                        size="large">
										<ArrowBackIosRoundedIcon fontSize="small"/>
									</IconButton>
								</Zoom>
								<Typography variant={"h4"} component={"h1"}
								            style={{paddingLeft: 6, display: "inline-block", verticalAlign: "bottom"}}>
									<b>Eventi</b>
								</Typography>
								<Typography variant={"subtitle2"} color={"textSecondary"} style={{paddingLeft: 6}}>
									Visualizza o crea un evento
								</Typography>
								<div className={classes.flexStart}>
									
									<div style={{width: "90%", flexGrow: 1, paddingLeft: 22, paddingRight: 22}}>
										<Tabs
											value={value}
											onChange={handleChange}
											textColor="primary"
											indicatorColor={"primary"}
											variant="scrollable"
											scrollButtons="auto"
											TabIndicatorProps={{
												style: {
													background: indigo["A700"],
													height: 5,
													borderRadius: "20px 20px 0 0"
												}
											}}
										>
											{/*metto i giorni da oggi a 15 gg*/}
											<Tab className={internalClasses.customTab}
											     label="martedì 15 marzo"/>
											<Tab className={internalClasses.customTab} label="mercoledì 16 marzo"/>
											<Tab className={internalClasses.customTab} label="giovedì 17 marzo"/>
											<Tab className={internalClasses.customTab} label="venerdì 18 marzo"/>
											<Tab className={internalClasses.customTab} label="sabato 21 marzo"/>
											<Tab className={internalClasses.customTab} label="domenica 22 marzo"/>
											<Tab className={internalClasses.customTab} label="lunedì 23 marzo"/>
											<Tab className={internalClasses.customTab} label="martedì 24 marzo"/>
											<Tab className={internalClasses.customTab} label="mercoledì 25 marzo"/>
											<Tab className={internalClasses.customTab} label="giovedì 26 marzo"/>
										</Tabs>
									</div>
									
									<TableContainer
										style={{paddingBottom: 8, backgroundColor: theme.palette.background.default, borderRadius: 22}}>
										<Table size={"small"}>
											<TableHead>
												<TableRow>
													{
														[8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map((item) => {
															return (
																<TableCell key={item} align={"center"}
																           style={{border: "none", width: 160, minWidth: 140}}>
																	<Typography style={{fontSize: 14}}>
																		<b>{item + ":00"}</b>
																	</Typography>
																</TableCell>
															)
														})
													}
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell colSpan={3} style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}>
														<EventoCard
															title={"Riunione per allineamento"}
															subtitle={"Allineamento pre-conferenza 2023"}
															place={"Sala Pensalfini"}
															color={orange}
															users={["Enrico Arnaudo", "Michele Luigi Greco"]}
															setEvento={(evento) => {
																setEventoSelected(evento);
																setOpen(true);
															}}
														/>
													</TableCell>
													{/*ne dovrei mettere 10 - 3 dove 3 è il colspan del primo*/}
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
												</TableRow>
												
												<TableRow>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell colSpan={2} style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}>
														<EventoCard
															title={"Evento verde"}
															subtitle={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam in iaculis mi, id" +
																" posuere metus. Nam purus augue, rutrum dignissim lacus eget, sollicitudin cursus nulla. " +
																"Praesent efficitur urna vitae nunc ullamcorper maximus. Aenean ac justo ante. Praesent in " +
																"consequat purus, ut varius turpis. Cras scelerisque vestibulum tortor, fringilla porta velit" +
																" mollis eget. Sed in mollis ligula, eu malesuada orci. Cras tincidunt nisl sit amet bibendum ornare."}
															place={"Laboratorio A1"}
															color={green}
															users={["Enrico Arnaudo", "Michele Luigi Greco", "Alessandro De Lorenzo", "Jacopo Verducci", "Ginevra Boncoraglio"]}
														/>
													</TableCell>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
												</TableRow>
												
												<TableRow>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell colSpan={2} style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}>
														<EventoCard
															title={"Evento rosso"}
															subtitle={"Donec tristique congue ultrices. Cras et lectus quis sem facilisis facilisis a id ipsum. " +
																"Sed quis nisi vel turpis bibendum tristique. Nunc non nibh a enim auctor interdum. " +
																"Proin molestie magna at sapien fermentum egestas."}
															place={"Ufficio Picco"}
															color={red}
															users={["Enrico Arnaudo", "Michele Luigi Greco", "Alessandro De Lorenzo", "Jacopo Verducci", "Ginevra Boncoraglio", "Paola Simone", "Giovanni Rossi"]}
														/>
													</TableCell>
												</TableRow>
												
												<TableRow>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell style={{
														border: "none",
														borderRight: theme.palette.mode === "light" ? "1px solid #eeeeee" : "1px solid #333333"
													}}/>
													<TableCell colSpan={8} style={{border: "none"}}>
														<EventoCard
															title={"Evento viola"}
															subtitle={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam in iaculis mi, id" +
																" posuere metus. Nam purus augue, rutrum dignissim lacus eget, sollicitudin cursus nulla. " +
																"Praesent efficitur urna vitae nunc ullamcorper maximus. Aenean ac justo ante. Praesent in " +
																"consequat purus, ut varius turpis. Cras scelerisque vestibulum tortor, fringilla porta velit" +
																" mollis eget. Sed in mollis ligula, eu malesuada orci. Cras tincidunt nisl sit amet bibendum ornare."}
															place={"Ufficio Barberis"}
															color={purple}
															users={["Jacopo Verducci", "Ginevra Boncoraglio", "Francesco Pensalfini", "Gianfranco Barberis"]}
														/>
													</TableCell>
													<TableCell colSpan={12} style={{border: "none"}}/>
												</TableRow>
											
											</TableBody>
										</Table>
									</TableContainer>
								
								</div>
								<div className={classes.flexEnd}>
									<Button className={classes.button} style={{borderRadius: 22}} variant={"contained"} disableElevation
									        onClick={() => setOpen(true)}>
										<b>Crea evento</b>
									</Button>
								</div>
							</Paper>
						</Slide>
					</Grid>
					<Grid item xs={12}
					      style={{
						      display: "flex",
						      alignItems: "center",
						      alignContent: "center",
						      justifyContent: "center",
						      position: "relative"
					      }}>
						<Typography variant={"caption"} color={"textSecondary"} align={"center"}>
							Atlantis© 2022<br/>
							Atlantis S.p.A 2022-2027<br/>
							Via San Paolo 33, Torino, TO
						</Typography>
						
						<IconButton
                            style={{position: "absolute", right: 4, bottom: 4}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
                                appContext.state.theme, appContext.dispatch)}
                            size="large">
							{appContext.state.theme.palette.mode === "light" ? <NightsStayTwoToneIcon/> : <WbSunnyTwoToneIcon/>}
						</IconButton>
					</Grid>
				</Grid>
				<CreaEventoDialog open={open} setOpen={(value) => {
					setOpen(value);
					setEventoSelected({});
				}} evento={eventoSelected}/>
			</main>
        </React.Fragment>
    );
}

export default React.memo(EventiPage);
